// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { GetNotificationDocuments} from '@api';



export const getNotificationDocuments = createAsyncThunk('notification/document_info', async args => {
  const response = await GetNotificationDocuments(args);
  return response.data;
})

export const notificationSlice = createSlice({
  name: 'notification',
  initialState: {
    documents: [],
   
  },
  reducers: {
    
  },
  extraReducers: builder => {
    builder
      .addCase(getNotificationDocuments.fulfilled, (state, action) => {
        state.documents = action.payload.documents;
      })
      

  }

})

export default notificationSlice.reducer

